export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-app text-primary-fg px-5 md:px-10 py-12">
      <div className="max-w-3xl mx-auto">
        <a href="/" className="text-sm text-tertiary-fg hover:text-primary-fg">← Torna alla home</a>
        <h1 className="font-display text-4xl font-semibold tracking-tight mt-6 mb-2">Informativa Privacy</h1>
        <p className="text-tertiary-fg text-sm">Conforme al GDPR (Reg. UE 2016/679) · Ultimo aggiornamento: Febbraio 2026</p>

        <div className="prose prose-invert mt-8 space-y-6 text-secondary-fg">
          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">1. Titolare del trattamento</h2>
            <p>Angelo Baliva — <a href="mailto:info@familybrain.it" className="text-brand">info@familybrain.it</a></p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">2. Dati raccolti</h2>
            <p>Raccogliamo:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Dati account</strong>: email, nome, password (hash bcrypt)</li>
              <li><strong>Dati famiglia</strong>: nome famiglia, codici invito, ruoli, codici referral</li>
              <li><strong>Contenuti</strong>: documenti caricati (PDF, immagini), messaggi chat, lista spesa, eventi calendario, note vocali</li>
              <li><strong>Dati di utilizzo</strong>: log accessi, contatori richieste AI giornaliere</li>
              <li><strong>Dati di pagamento</strong>: gestiti esclusivamente da Stripe (non memorizziamo carte)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">3. Finalità del trattamento</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Fornire il Servizio (registrazione, autenticazione, archiviazione)</li>
              <li>Elaborazione AI dei contenuti (classificazione, risposte, trascrizione)</li>
              <li>Gestione pagamenti</li>
              <li>Invio email transazionali (benvenuto, conferma pagamento, reminder)</li>
              <li>Sicurezza e prevenzione abusi</li>
              <li>Adempimento obblighi legali</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">4. Base giuridica</h2>
            <p>Il trattamento si basa su: (a) esecuzione del contratto, (b) consenso esplicito, (c) interesse legittimo, (d) obblighi di legge.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">5. Conservazione dati</h2>
            <p>I tuoi dati restano memorizzati finché mantieni l&apos;account attivo. Alla cancellazione, vengono eliminati entro 30 giorni, fatti salvi obblighi di conservazione fiscale (10 anni per fatture).</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">6. Condivisione dei dati</h2>
            <p>Condividiamo dati strettamente necessari con i seguenti sub-responsabili:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>OpenAI (GPT-5.2, Whisper)</strong>: elaborazione AI dei contenuti — sede USA, conforme DPF EU-USA</li>
              <li><strong>Stripe</strong>: gestione pagamenti — sede USA/Irlanda, conforme GDPR</li>
              <li><strong>Resend</strong>: invio email transazionali — sede USA, conforme DPF</li>
              <li><strong>Emergent (hosting)</strong>: infrastruttura server e database</li>
            </ul>
            <p>Non vendiamo né cediamo i tuoi dati a terzi per finalità di marketing.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">7. I tuoi diritti (GDPR Art. 15-22)</h2>
            <p>Hai diritto a:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Accedere ai tuoi dati (esporta dalle Impostazioni)</li>
              <li>Rettificare dati inesatti</li>
              <li>Cancellare i dati (&ldquo;diritto all&apos;oblio&rdquo;) — vedi <a href="/delete-account" data-testid="privacy-delete-account-link" className="text-brand hover:underline">come eliminare l&apos;account</a></li>
              <li>Limitare o opporti al trattamento</li>
              <li>Portabilità dei dati</li>
              <li>Revocare il consenso in qualsiasi momento</li>
              <li>Presentare reclamo al Garante Privacy (https://www.garanteprivacy.it)</li>
            </ul>
            <p>Per esercitare i diritti: <a href="mailto:info@familybrain.it" className="text-brand">info@familybrain.it</a></p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">8. Sicurezza</h2>
            <p>Adottiamo misure tecniche e organizzative per proteggere i dati: cifratura TLS in transito, password hashate con bcrypt, JWT con scadenza, accessi limitati al database, backup giornalieri.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">9. Minori</h2>
            <p>Il Servizio non è destinato a minori di 14 anni. Se sei un genitore e ritieni che un minore ci abbia fornito dati, contattaci per la cancellazione.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">10. Cookie</h2>
            <p>Usiamo solo cookie tecnici (JWT auth) e di analytics (PostHog) per migliorare il servizio. Nessun cookie pubblicitario o di profilazione.</p>
          </section>

          <p className="text-xs text-tertiary-fg pt-8 border-t border-subtle">
            ⚠️ Questo è un template GDPR di base. Per uso commerciale ti consigliamo di personalizzarlo con un avvocato specializzato o usare servizi tipo Iubenda.com.
          </p>
        </div>
      </div>
    </div>
  );
}
